import React, { Component } from 'react';
import { useParams, useNavigate, Link  } from 'react-router-dom';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import moment from 'moment';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
/* import { GET_VIEWUSERLIST } from '../../actions'; */
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
class View extends Component {
  
  constructor(props)
  {
    super(props); 
    const userid = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;

    this.state = {      
      userid: userid,
      userlistview:'',
      planList:[],
      socialMediaList:[],
    };

    
  }

   
   componentDidMount() {
     document.title = PageTitle('User View');
     this.newDataloader();
   }

   componentDidUpdate(prevProps,prevState){

   }
   componentWillReceiveProps(Props){
   
    
   }
  newDataloader = () => {
    axios.get(apiUrl+"adminuser/listdetail?id="+this.state.userid).then(res => {
      if(res.data.status == 'success'){
        const formdata = res.data.userlist;
        const planListData = res.data.planList;
        const socialMediaListData = res.data.socialMediaList;
        if(formdata.status === 'A'){
          this.setState({selectedOption:{value: 'active', label: 'Active'}});
        }else{
          this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});

        }
        this.setState({userlistview:res.data.userlist, planList : this.planList(planListData), socialMediaList : this.socialMediaList(socialMediaListData)});     
      }
    }); 
  }

  planList(planListData=null) {
    var planlist = planListData;
    if (planlist != "undefined" && planlist != null) {
      //if ( == "success"){
        if (Object.keys(planlist).length > 0) {
          const planlistDetails = planlist.map(
            (planlist, Index) => {
              let sno = Index+1;
              return (
                <tr key={planlist.id}>
				         <td>{sno}</td>
                   <td>
                  
                  {moment(planlist.created_date).format('DD MMM YYYY, h:mm A')}
                  </td>
                  <td>
                  {planlist.subscription_title} { ' - '+planlist.subscription_price}/{planlist.subscription_plan_terms}
                  </td>
                  {/* <td>
                  {planlist.paid_amount}/{planlist.period=='month'?'m':'y'}
                  </td>
                 */}
                  <td>
                  {planlist.plan_status=='A' ? 'Active' : 'Inactive'}
                  </td>
                </tr>
              );
            }
          );
          return planlistDetails;
        }else {
          return (
            <tr>
              <td colspan="5" className="v-align-nr">
               No plan found
              </td>
            </tr>
          );
        }
      
    }else {
      return (
        <tr>
          <td colspan="4" className="v-align-nr">
            No plan found
          </td>
        </tr>
      );
    }
  }
  socialMediaList(socialMediaListData=null) {
    var socialMediaList = socialMediaListData;
    if (socialMediaList != "undefined" && socialMediaList != null) {
      //if ( == "success"){
        if (Object.keys(socialMediaList).length > 0) {
          const socialMediaListDetails = socialMediaList.map(
            (socialMediaList, Index) => {
              let sno = Index+1;
              return (
                <div className="view-details"  key={socialMediaList.id}>
                  <div className="view-details-one">
                    <p>
                      <b>
                        {
                        (socialMediaList.business_type == 'facebook') ? 'Facebook' :
                        (socialMediaList.business_type == 'whatsapp') ? 'Whatsapp' :
                        (socialMediaList.business_type == 'twitter') ? 'Twitter' :
                        (socialMediaList.business_type == 'pinterest') ? 'Pinterest' :
                        (socialMediaList.business_type == 'instagram') ? 'Instagram' :
                        'Social Media Link'
                        }
                      <span>:</span> </b>
                    </p>
                  </div>
                  <div className="view-details-two">
                    <p>{socialMediaList.link}</p>
                  </div>
                </div>
              );
            }
          );
          return socialMediaListDetails;
        }else {
          return (
            <div className="view-details" >
              No social media link found
            </div>
          );
        }
      
    }else {
      return (
        <div className="view-details" >
          No social media link found
        </div>
      );
    }
  }
   
  render() {
    

    var mobileno = ((this.state.userlistview.mobile === null)||((this.state.userlistview.mobile === ''))) ?  this.state.userlistview.mobile = 'N/A' : this.state.userlistview.mobile;

    var lastname = ((this.state.userlistview.lastname === null)||(this.state.userlistview.lastname === "")) ?  this.state.userlistview.lastname = 'N/A' : this.state.userlistview.lastname;

    //var full_address = ((this.state.userlistview.full_address == null)||(this.state.userlistview.full_address == '')) ?  this.state.userlistview.full_address = 'N/A' : this.state.userlistview.full_address;

    if(this.state.userlistview.status == 'A'){
      var status = 'Active';
    }else{
        var status = 'Inactive';
    }
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="user" />  
      
      <div className="content"> 
        <div className="content-wrapper">
          <div class="content-wrapper-before"></div>
            <div className="content-body">
              <div className="form-wrapper leaa-admin-head card">
                {/* <div className="title">
                  <h3>User Details</h3>
                </div> */}
                <div className="listing-header"> 
                  <div className="title">
                    <h3>User Details</h3>
                  </div>
                  <div className="add_button">  
                    <a className="" href='/user'><i class="fa fa-arrow-left" aria-hidden="true"></i> Back</a>              
                  </div>
                </div>
                <div className="form-row">
                    <div className="details_left">
                        <div className="view-details">
                          <div className="view-details-one">
                            <p><b>User Name<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                            <p>{this.state.userlistview.username}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                            <p><b>First Name<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                            <p>{this.state.userlistview.firstname}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                            <p><b>Last Name<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                            <p>{lastname}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                            <p><b>Email<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                            <p>{this.state.userlistview.email}</p>
                          </div>
                        </div>
                        <div className="view-details">
                          <div className="view-details-one">
                            <p><b>Contact<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                            <p>{mobileno}</p>
                          </div>
                        </div>                                                
                        <div className="view-details">
                          <div className="view-details-one">
                            <p><b>Address<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                            <p>{(this.state.userlistview.full_address != null && this.state.userlistview.full_address != '') ? this.state.userlistview.full_address : 'N/A'}</p>
                          </div>
                        </div>                                                
                        <div className="view-details">
                          <div className="view-details-one">
                            <p><b>Status<span>:</span> </b></p>
                          </div>
                          <div className="view-details-two">
                            <p>{status}</p>
                          </div>
                        </div>
                    </div>
                </div>
                  <div className="title">
                    <h3>Social media details</h3>
                  </div>
                  <div className="form-row">
                    <div className="details_left">
                        {this.state.socialMediaList}                     
                    </div>
                  </div>
                  <div className="title">
                    <h3>Membership details</h3>
                  </div>
                  <div className="car-listing-row">
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Subscribed On</th>
                          <th>Package</th>
                          {/* <th> Amount/Period</th> */}
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>{this.state.planList}</tbody>
                    </Table>
                    {/* <div className="text-center">
                      <Pagination
                      activePage={this.state.activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={this.state.totalRecord}
                      pageRangeDisplayed={5}
                      onChange={this.handlePageChange.bind(this)}
                      />
                    </div> */}
                  </div>
                 
                  
               
              </div>            
            </div>
          </div> 
        </div>        
    </div>
    );
  }
}
export default withRouter(View);
